import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Pause = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="pause icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H8.49901C9.60397 22 10.4996 21.104 10.499 19.999L10.4911 3.99901C10.4906 2.89483 9.59531 2 8.49112 2H4ZM15.5 2C14.3954 2 13.5 2.89543 13.5 4V20C13.5 21.1046 14.3954 22 15.5 22H19.9972C21.1029 22 21.9987 21.1029 21.9972 19.9972L21.9747 3.99719C21.9732 2.89372 21.0782 2 19.9747 2H15.5Z"
    />
  </svg>
)
